export const API_ROOT = process.env.REACT_APP_API_ROOT || "";

export const CLOUDINARY_CLOUDNAME =
  process.env.REACT_APP_CLOUDINARY_CLOUDNAME || "";
